import { InfoOutlined } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { ICoursesCalendarRideProducePreviewHintProps } from "./courses-calendar-ride-produce.models";

export const CoursesCalendarRideProducePreviewHint: FC<
  ICoursesCalendarRideProducePreviewHintProps
> = ({ hintKey, total, pending, skipped = 0 }) => {
  const { t } = useTranslation();
  const hintText = t(hintKey, { total, pending });
  const skippedSuffix =
    skipped > 0
      ? t("course.calendar.producePreviewHintSkippedSuffix", { skipped })
      : "";
  // Drop trailing "." so suffix can continue with ", N will be skipped"
  const message = skippedSuffix
    ? `${hintText.replace(/\.\s*$/, "")}${skippedSuffix}`
    : hintText;

  return (
    <div className="cc-ride-produce-alert" role="status">
      <span className="cc-ride-produce-alert__icon" aria-hidden>
        <InfoOutlined fontSize="small" />
      </span>
      <span>{message}</span>
    </div>
  );
};
